<template>
  <div class="page-schedule-event">
    <ActiveEventPanel :event="event" />
  </div>
</template>

<script>
import getEvents from '@/mixins/getEvents'
import ActiveEventPanel from '@/components/schedule/ActiveEventPanel'

export default {
  name: 'ScheduleEvent',
  components: { ActiveEventPanel },
  mixins: [getEvents],
  computed: {
    id() {
      return +this.$route.params.event
    },
    event() {
      return this.events.find((event) => event.id === this.id)
    },
  },
}
</script>

<style lang="scss">
.page-schedule-event {
}
</style>
